import { between, changeSelectOptions } from './functions.js';

export default function SelectValueModule(element) {

    let initialValue = element.getAttribute('value');

    this.loadInitialValue = function() {
        if (initialValue) {
            element.value = initialValue;
        }
    }

    this.loadInitialValue();

    return this;

}
